import { View, Text, ScrollView, Pressable, ImageBackground } from 'react-native'
import React, { useEffect, useLayoutEffect, useState } from 'react'
import AsyncStorage from '@react-native-async-storage/async-storage';
import GlobalStyles from './../style';
import alert from './../alert';
import { useNavigation } from '@react-navigation/native';
import DropDownPicker from 'react-native-dropdown-picker';
import { useSelector } from 'react-redux'
import dr from './../datosReferenciales.json'
import transl from './../translations/transl'

let lang = undefined;

const Objects = () => {
  const navigation = useNavigation();

  //pociones curativas
  const [open, setOpen] = useState(false);
  const [playerCure, setPlayerCure] = useState(null);
  const [items, setItems] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);

  //piedra filosofal
  const [open2, setOpen2] = useState(false);
  const [playerToYoung, setPlayerToYoung] = useState(null);
  const [items2, setItems2] = useState([]);
  const [selectedIndex2, setSelectedIndex2] = useState(null);

  useLayoutEffect(() => {
      navigation.setOptions({
          //headerShown: false,
          headerTitle: transl('MainMenu.objetos', lang)
      })
  }, []);

  //reading data
  const [value, setvalue] = useState('');
  const readValue = async () => {
    await AsyncStorage.getItem('equipos')
      .then((value) => {
        setvalue(value)
        setThings(value,navigation);
      })
  }
  useEffect(() => {
    readValue();
  }, []);

  const [equipo, setEquipo] = useState(null);

  useEffect(() => {
    const load = async () => {
      const raw = await AsyncStorage.getItem('equipos');
      if (raw) setEquipo(JSON.parse(raw));
    }
    load();
  }, []);
  lang = dr.idiomas[useSelector((state) => state.language)]?.value

  return (
    <View style={{flex:1}}>
      <ImageBackground source={require('./../img/background4.png')} resizeMode="cover" style={{flex:1}}>
        <ScrollView>
          <Text style={[GlobalStyles.textForTitleScreen,{marginVertical:60}]}>{transl('MainMenu.objetos', lang)}</Text>
          {value ? <ContenidoObjetos data={JSON.parse(value)} /> : <Text>{transl('General.cargando', lang)}</Text>}
        </ScrollView>
      </ImageBackground>
    </View>
  )

  function setThings(data,nav) {
    if (data === undefined || !data) return <Text>{transl('General.cargando', lang)}</Text>
    data = data != null ? JSON.parse(data) : null

    if(!data.profile.objects){
      checkInMatchStatsExist(data)
      saveData(data)
      return <Text>Si quieres ver el inventario de objetos, deberás comprar antes algún objeto en Mercado.</Text>
    }

    let myInjuredPlayers = []
    if(data !== undefined && data) {
        for(let i = 0; i < data.teams[0].players.length; i++){
          if(data.teams[0].players[i].injury <= 0) continue
          myInjuredPlayers.push({
            label: data.teams[0].players[i].name,
            value: i
          })
        }
    }
    console.log("setting players")
    let allPlayers = data.teams[0].players.map((player, index) => ({
      label: player.name,
      value: index
    }));
    console.log(allPlayers)

    return(
    <View style={{marginHorizontal:50}}>
      <View style={{marginBottom:75}}>
        <Text style={[GlobalStyles.textH2]}>{transl('Objects.pocionesCurativas', lang, [data.profile.objects.pocionCurativa])}</Text>
        <View style={{marginHorizontal:25, marginTop:25}}>
          <DropDownPicker
                      open={open}
                      value={playerCure}
                      items={myInjuredPlayers}
                      setOpen={setOpen}
                      setValue={setPlayerCure}
                      setItems={setItems}
                      onSelectItem={(item) => setSelectedIndex(item.value)}
                      selectedItemContainerStyle={{
                          backgroundColor: "#cccccc"
                      }}
                      selectedItemLabelStyle={{
                          backgroundColor: "#cccccc"
                      }}
                      scrollViewProps={{
                        scrollEnabled: true,
                      }}
                      autoScroll={true}
                      listMode="SCROLLVIEW"
                  />
        </View>
        <View style={[GlobalStyles.buttonMargins,{marginTop:20,marginLeft: 'auto', marginRight: 'auto'}]}>
          <Pressable
            style={(data.profile.objects.pocionCurativa == 0) ? GlobalStyles.buttonMainDisabled : GlobalStyles.buttonMain}
            disabled = {data.profile.objects.pocionCurativa == 0}
            onPress={() => {check(data,navigation,1,{player:playerCure})}}>
            <Text style={GlobalStyles.textForButtonMain}>{transl('Objects.curarJugador', lang)}</Text>
          </Pressable>
        </View>
      </View>
      <View style={{marginBottom:150}}>
        <Text style={[GlobalStyles.textH2]}>{transl('Market.felixFelicis', lang)}: {data.profile.objects.felixFelicis}</Text>
        <View style={[GlobalStyles.buttonMargins,{marginTop:20,marginLeft: 'auto', marginRight: 'auto'}]}>
          <Pressable
            style={(data.profile.objects.felixFelicis == 0 || data.others.inmatchStates.felixFelicis) ? GlobalStyles.buttonMainDisabled : GlobalStyles.buttonMain}
            disabled = {data.profile.objects.felixFelicis == 0 || data.others.inmatchStates.felixFelicis}
            onPress={() => {check(data,navigation,2)}}>
            <Text style={GlobalStyles.textForButtonMain}>{transl('Objects.usarFelix', lang)}</Text>
          </Pressable>
        </View>
      </View>
      <View style={{marginBottom:150}}>
        <Text style={[GlobalStyles.textH2]}>{transl('Objects.fragmentosPiedra', lang, [data.profile.objects.piedraFilosofal])}</Text>
        <View style={{marginHorizontal:25, marginTop:25}}>
          <DropDownPicker
                      open={open2}
                      value={playerToYoung}
                      items={allPlayers}
                      setOpen={setOpen2}
                      setValue={setPlayerToYoung}
                      setItems={setItems2}
                      onSelectItem={(item) => setSelectedIndex2(item.value)}
                      selectedItemContainerStyle={{
                          backgroundColor: "#cccccc"
                      }}
                      selectedItemLabelStyle={{
                          backgroundColor: "#cccccc"
                      }}
                      scrollViewProps={{
                        scrollEnabled: true,
                      }}
                      autoScroll={true}
                      listMode="SCROLLVIEW"
                  />
        </View>
        <View style={[GlobalStyles.buttonMargins,{marginTop:20,marginLeft: 'auto', marginRight: 'auto'}]}>
          <Pressable
            style={(data.profile.objects.piedraFilosofal == 0) ? GlobalStyles.buttonMainDisabled : GlobalStyles.buttonMain}
            disabled = {data.profile.objects.piedraFilosofal == 0}
            onPress={() => {check(data,navigation,3,{player:playerToYoung})}}>
            <Text style={GlobalStyles.textForButtonMain}>{transl('Objects.rejuvenecerJugador', lang)}</Text>
          </Pressable>
        </View>
      </View>
      <View style={{marginBottom:150}}>
        <Text style={[GlobalStyles.textH2]}>Pociones Multijugos: {data.profile.objects.pocionMultijugos}</Text>
        <Text style={{textAlign:'center'}}>Soon...</Text>
      </View>
      <View style={{marginBottom:150}}>
        <Text style={[GlobalStyles.textH2]}>Hechizos Confundus: {data.profile.objects.hechizoConfundus}</Text>
        <Text style={{textAlign:'center'}}>Soon...</Text>
      </View>
    </View>
    )
  }

  function checkInMatchStatsExist (data) {
    if(!(data.others && 'inmatchStates' in data.others)) data.others.inmatchStates = {felixFelicis:false,felixFelicisEnemy:false,confundus:false,confundusEnemy:false};
    if(!(data.profile && 'objects' in data.profile)) data.profile.objects = {felixFelicis:0,piedraFilosofal:0,pocionCurativa:0,pocionMultijugos:0,hechizoConfundus:0,polvoHerrero:0}
    return data
  }
  
}

const ContenidoObjetos = ({ data }) => {
  const [open, setOpen] = useState(false);
  const [playerCure, setPlayerCure] = useState(null);
  const [items, setItems] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const [open2, setOpen2] = useState(false);
  const [playerToYoung, setPlayerToYoung] = useState(null);
  const [items2, setItems2] = useState([]);
  const [selectedIndex2, setSelectedIndex2] = useState(null);

  const navigation = useNavigation(); // o pásalo por props si prefieres

  //const lang = dr.idiomas[useSelector((state) => state.language)].value;

  const myInjuredPlayers = data.teams[0].players
    .map((p, i) => p.injury > 0 ? { label: p.name, value: i } : null)
    .filter(Boolean);

  const allPlayers = data.teams[0].players.map((p, i) => ({ label: p.name, value: i }));

  const check = (data,nav,state,moreInfo = {}) => {
    console.log(moreInfo)
    console.log("state: "+state)
    if(moreInfo.player === null && (state < 1 && state > 3)) {
      alert(transl('General.info', lang),transl('Objects.debesSeleccionar', lang),[
        {text: transl('General.OK', lang), onPress: () => void(0), style: "cancel"}
      ])
      return
    }
    let textInfo = "";
    if(state==1) textInfo = transl('Objects.seCurara', lang, [data.teams[0].players[moreInfo.player].name])
    else if(state==2) textInfo = transl('Objects.seAplicara', lang)
    else if(state==3) textInfo = transl('Objects.rejuvenecera', lang, [data.teams[0].players[moreInfo.player].name])
    textInfo += transl('Objects.seguir', lang)
  
    alert(transl('General.info', lang),textInfo,[
      {text: transl('General.cancelar', lang), onPress: () => void(0), style: "cancel"},
      {text: transl('General.OK', lang), onPress: () => {
          if(state==1)curePlayer(data,nav,moreInfo.player)
          else if(state==2)definitelyUseFelix(data,nav)
          else if(state==3)defineltyUsePhilosofers(data,nav,moreInfo.player)
        }
      }
    ])
  }

  const curePlayer = (data,nav,player) => {
    data.profile.objects.pocionCurativa--;
    data.teams[0].players[player].injury--;
    saveData(data)
    objetoUsadoAndOut(transl('Market.pocionCurativa', lang),nav);
  }
  const definitelyUseFelix = (data,nav) => {
    data.profile.objects.felixFelicis--;
    data = checkInMatchStatsExist(data);
    data.others.inmatchStates.felixFelicis = true;
    saveData(data)
    objetoUsadoAndOut(transl('Market.felixFelicis', lang),nav);
  }
  const defineltyUsePhilosofers = (data,nav,player) => {
    data.profile.objects.piedraFilosofal--;
    if(data.teams[0].players[player].age <= 18) {
      alert(transl('General.info', lang),transl('Objects.noTendraEfecto', lang),[
        {text: transl('General.OK', lang), onPress: () => void(0), style: "cancel"}
      ])
      return
    }
    data.teams[0].players[player].age--;
    saveData(data)
    objetoUsadoAndOut(transl('Market.fragmentoPiedra', lang),nav);
  }
  const objetoUsadoAndOut = (object,nav) => {
    alert(transl('General.info', lang),transl('Objects.objetoUsado', lang, [object]),[
      {text: transl('General.OK', lang), onPress: () => void(0), style: "cancel"}
    ])
    nav.navigate('HomeScreen')
  }
  

  const saveData = (data) => {
    console.log("save info")
    if(typeof data != "object")data = data != null ? JSON.parse(data) : null
    
    const storeData = async (data) => {
      try {
        const jsonValue = JSON.stringify(data)
        await AsyncStorage.setItem('equipos', jsonValue)
      } catch (e) {
        console.log("error saving file")
        console.log(e)
      }
    }
    storeData(data)
  }


  //check()
  useEffect(() => {
    const timer = setTimeout(() => {
      if (data) saveData(data)
    }, 0) // ejecuta después del primer render
  
    return () => clearTimeout(timer)
  }, [data])

  return (
    <View style={{marginHorizontal:50}}>
      <View style={{marginHorizontal:50}}>
      <View style={{marginBottom:75}}>
        <Text style={[GlobalStyles.textH2]}>{transl('Objects.pocionesCurativas', lang, [data.profile.objects.pocionCurativa])}</Text>
        <View style={{marginHorizontal:25, marginTop:25, zIndex:10}}>
          <DropDownPicker
                      open={open}
                      value={playerCure}
                      items={myInjuredPlayers}
                      setOpen={setOpen}
                      setValue={setPlayerCure}
                      setItems={setItems}
                      onSelectItem={(item) => setSelectedIndex(item.value)}
                      selectedItemContainerStyle={{
                          backgroundColor: "#cccccc"
                      }}
                      selectedItemLabelStyle={{
                          backgroundColor: "#cccccc"
                      }}
                      scrollViewProps={{
                        scrollEnabled: true,
                      }}
                      autoScroll={true}
                      listMode="SCROLLVIEW"
                      ListEmptyComponent={() => (
                        <Text style={{ textAlign: 'center', padding: 10 }}>
                          {transl('Objects.sinJugadoresLesionados')}
                        </Text>
                      )}
                  />
        </View>
        <View style={[GlobalStyles.buttonMargins,{marginTop:20,marginLeft: 'auto', marginRight: 'auto'}]}>
          <Pressable
            style={(data.profile.objects.pocionCurativa == 0) ? GlobalStyles.buttonMainDisabled : GlobalStyles.buttonMain}
            disabled = {data.profile.objects.pocionCurativa == 0}
            onPress={() => {check(data,navigation,1,{player:playerCure})}}>
            <Text style={GlobalStyles.textForButtonMain}>{transl('Objects.curarJugador', lang)}</Text>
          </Pressable>
        </View>
      </View>
      <View style={{marginBottom:150}}>
        <Text style={[GlobalStyles.textH2]}>{transl('Market.felixFelicis', lang)}: {data.profile.objects.felixFelicis}</Text>
        <View style={[GlobalStyles.buttonMargins,{marginTop:20,marginLeft: 'auto', marginRight: 'auto'}]}>
          <Pressable
            style={(data.profile.objects.felixFelicis == 0 || data.others.inmatchStates.felixFelicis) ? GlobalStyles.buttonMainDisabled : GlobalStyles.buttonMain}
            disabled = {data.profile.objects.felixFelicis == 0 || data.others.inmatchStates.felixFelicis}
            onPress={() => {check(data,navigation,2)}}>
            <Text style={GlobalStyles.textForButtonMain}>{transl('Objects.usarFelix', lang)}</Text>
          </Pressable>
        </View>
      </View>
      <View style={{marginBottom:150}}>
        <Text style={[GlobalStyles.textH2]}>{transl('Objects.fragmentosPiedra', lang, [data.profile.objects.piedraFilosofal])}</Text>
        <View style={{marginHorizontal:25, marginTop:25, zIndex:9}}>
          <DropDownPicker
                      open={open2}
                      value={playerToYoung}
                      items={allPlayers}
                      setOpen={setOpen2}
                      setValue={setPlayerToYoung}
                      setItems={setItems2}
                      onSelectItem={(item) => setSelectedIndex2(item.value)}
                      selectedItemContainerStyle={{
                          backgroundColor: "#cccccc"
                      }}
                      selectedItemLabelStyle={{
                          backgroundColor: "#cccccc"
                      }}
                      scrollViewProps={{
                        scrollEnabled: true,
                      }}
                      autoScroll={true}
                      listMode="SCROLLVIEW"
                  />
        </View>
        <View style={[GlobalStyles.buttonMargins,{marginTop:20,marginLeft: 'auto', marginRight: 'auto'}]}>
          <Pressable
            style={(data.profile.objects.piedraFilosofal == 0) ? GlobalStyles.buttonMainDisabled : GlobalStyles.buttonMain}
            disabled = {data.profile.objects.piedraFilosofal == 0}
            onPress={() => {check(data,navigation,3,{player:playerToYoung})}}>
            <Text style={GlobalStyles.textForButtonMain}>{transl('Objects.rejuvenecerJugador', lang)}</Text>
          </Pressable>
        </View>
      </View>
      <View style={{marginBottom:150}}>
        <Text style={[GlobalStyles.textH2]}>Pociones Multijugos: {data.profile.objects.pocionMultijugos}</Text>
        <Text style={{textAlign:'center'}}>Soon...</Text>
      </View>
      <View style={{marginBottom:150}}>
        <Text style={[GlobalStyles.textH2]}>Hechizos Confundus: {data.profile.objects.hechizoConfundus}</Text>
        <Text style={{textAlign:'center'}}>Soon...</Text>
      </View>
    </View>
    </View>
  );
};

export default Objects